<!-- <mat-icon mat-dialog-close class="close-btn" (click)="close()">clear</mat-icon> -->
<mat-dialog-content style="display:flex;flex-direction:column; height:100%">
    <span style="flex: 1;"></span>
    <div style="max-width: 500px; margin:auto;">
        <h2 style="text-align:center;">Tide 2.0 Seed Fund Criteria</h2>

        <p style="margin:0;">
            <b>Start-Up Support Grant-</b>  INR 7 Lacs and EIR - INR 4 Lacs
            <br><br>
            <b>Eligibility:</b>
        </p>
        <ul>
            <li>1. Start-ups developing innovative digital solutions for health care, edutech, agriculture,
                Infrastructure & Transportation, ICT and CleanTech and who have completed Proof of Concept (PoC)</li>
            <li>2. Indian Start-ups (registered under Companies Act, 2013), having at least 51% shareholders as Indian
                Citizens [does not include OCI or PIO] is the mandatory requirement</li>
        </ul>
        <p>
            <br>
            <b>Stage of Development:</b> Proof of Concept (PoC) to Minimum Viable Product (MVP)
            <br><br>
            <b>Seed Grant Support for:</b> Creating a Minimum Viable Product and to advance the start-up till
            Go-to-the-market stage

        </p>

        <button type="button" class="theme-btn mb" (click)="close()" style="margin:auto; margin-top: 70px;">
            Continue
        </button>

    </div>

    <span style="flex: 1;"></span>
</mat-dialog-content>

<div mat-dialog-actions class="dsk">
    <span style="flex: 1;"></span>
    <button type="button" class="theme-btn" (click)="close()" id="btn">
        {{btnText}}
    </button>
    <span style="flex: 1;" class="mb"></span>
</div>